import './App.css';
import Navbar from './components/Navbar';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Review from './pages/Review';
import Reviews from './pages/Reviews';
import Diffs from './pages/Diffs';
import Diff from './pages/Diff';
import Commits from './pages/Commits';
import Commit from './pages/Commit';
import Discrepancies from './pages/Discrepancies';
import Discrepancy from './pages/Discrepancy';
import GenReviews from './pages/GenReviews';
import GenReview from './pages/GenReview';
import GenReviewsDiffs from './pages/GenReviewsDiffs';
import GenReviewsDiff from './pages/GenReviewsDiff';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/review/:id/:sha_ini/:sha_fix" element={<Review />} />
        <Route path="/diffs" element={<Diffs />} />
        <Route path="/diff/:id/:sha_ini/:sha_fix" element={<Diff />} />
        <Route path="/commits" element={<Commits />} />
        <Route path="/commit/:sha" element={<Commit />} />
        <Route path="/discrepancies" element={<Discrepancies />} />
        <Route path="/discrepancy/:sha" element={<Discrepancy />} />
        <Route path="/genReviews" element={<GenReviews />} />
        <Route path="/genReview/:sha" element={<GenReview />} />
        <Route path="/genReviewsDiffs" element={<GenReviewsDiffs />} />
        <Route path="/genReviewsDiff/:sha/:model/:prompt" element={<GenReviewsDiff />} />
      </Routes>
    </div>
  );
}

export default App;
